const entity = 'dogs'
const entitySingle = 'dog'
const tableIcon = 'cil-paw'

export {
  entity,
  entitySingle,
  tableIcon
}
